export enum TipoModelo {
  Prescricao = 'prescricao',
  Laudo = 'laudo',
  Rotina = 'rotina',
  Encaminhamento = 'encaminhamento',
  ExamesComplementares = 'examescomplementares',
}

export const TipoModeloLabel: Record<TipoModelo, string> = {
  [TipoModelo.Prescricao]: 'Prescrição',
  [TipoModelo.Laudo]: 'Laudo',
  [TipoModelo.Rotina]: 'Rotina',
  [TipoModelo.Encaminhamento]: 'Encaminhamento',
  [TipoModelo.ExamesComplementares]: 'Exames Complementares',
};
